/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const REPORT_NAMES_DEFAULT = [
  'DRIVER_CATEGORY_AND_SCORE',
  'DRIVER_SCORE_AND_COMPARISON',
  'DRIVING_INCIDENTS',
  'DRIVER_SCORE_TREND',
  'VEHICLE_SUMMARY_ALERT_COUNT',
];

export const REPORT_NAMES_TRIP = [
  'DRIVER_CATEGORY_AND_SCORE_TRIP',
  'DRIVER_SCORE_AND_COMPARISON_TRIP',
  'DRIVING_INCIDENTS_TRIP',
  'DRIVER_SCORE_TREND_TRIP',
  'TRIP_SUMMARY_ALERT_COUNT_TRIP',
];

export const REPORT_NAMES_TRIP_WISE = [
  'DRIVER_CATEGORY_AND_SCORE_RIGHT_BANNER_TRIP',
  'DRIVER_CATEGORY_AND_SCORE_TRIP',
  'DRIVER_SCORE_AND_COMPARISON_TRIP',
  'DRIVING_INCIDENTS_TRIP',
  'DRIVER_SCORE_TREND_TRIP',
  'TRIP_SUMMARY_ALERT_COUNT_TRIP',
];

export const DEF_SEARCH_PARAM = {
  vehicleIds: [],
  fromTsInIST: moment(new Date())
    .subtract(1, 'day')
    .startOf('day')
    .format('YYYY-MM-DD HH:mm:ss'),
  toTsInIST: moment(new Date())
    .subtract(1, 'day')
    .endOf('day')
    .format('YYYY-MM-DD HH:mm:ss'),
  reportName: REPORT_NAMES_DEFAULT,
  groupNames: [],
};

export const TableHeadName = [
  {
    name: 'Registration No',
    id: 'RegistrationNumber',
    minWidth: '185px',
    sort: true,
  },
  {
    name: 'Driver Score',
    id: 'DriverScore',
    isTooltip: true,
    dataTip: 'Driver Score',
    dataInfo:
      '100 - Σ (Incident score of every enabled Alerts)/No of enabled Alerts',
    minWidth: '130px',
    sort: true,
    icon: 'drivingReport',
  },
  {
    name: 'Driver Score Category',
    id: 'DriverScoreCategory',
    minWidth: '160px',
  },
  {
    name: 'Total Distance',
    id: 'TotalDistance',
    sort: true,
    unitConversion: '(km)',
  },
  {
    name: 'Total Driving Time',
    id: 'TotalDrivingTime',
    convert: true,
    sort: true,
    unitConversion: '(HH:MM:SS)',
    minWidth: '170px',
  },
  {
    name: 'Fuel Consumed',
    id: 'FuelConsumed',
    sort: true,
    unitConversion: '(ltrs)',
    minWidth: '160px',
  },
  // {
  //   name: 'Adblue Consumed',
  //   id: 'AdblueConsumed',
  //   sort: true,
  //   unitConversion: '(ltrs)',
  //   minWidth: '170px',
  // },
  {
    name: 'Fuel Drop',
    id: 'FuelDrop',
    unitConversion: '(ltrs)',
    sort: true,
  },
  {
    name: 'Max Speed',
    id: 'MaxSpeed',
    sort: true,
    unitConversion: '(kmph)',
    minWidth: '130px',
  },
  {
    name: 'Driving within Economy',
    id: 'DrivingWithEconomy',
  },
  {
    name: 'Overspeed',
    id: 'Overspeed',
  },
  {
    name: 'Idling',
    id: 'Idling',
  },
  {
    name: 'Neutral',
    id: 'Neutral',
  },
  {
    name: 'Night Driving',
    id: 'NightDriving',
  },
  {
    name: 'Excessive Driving',
    id: 'ExcessiveDriving',
  },
  {
    name: 'Harsh Acceleration',
    id: 'TOTALHA',
    sort: true,
    unitConversion: '(count)',
    minWidth: '180px',
  },
  {
    name: 'Harsh Braking',
    id: 'TOTALHB',
    sort: true,
    unitConversion: '(count)',
    minWidth: '150px',
  },
  {
    name: 'Harsh Cornering',
    id: 'TOTALHC',
    sort: true,
    unitConversion: '(count)',
    minWidth: '160px',
  },
  {
    name: 'Engine Overrun',
    id: 'EngineOverrun',
    sort: true,
    unitConversion: '(count)',
    minWidth: '160px',
  },
];

export const TableSubHeadName = [
  {
    name: 'Driving duration',
    id: 'DriveDuration',
    unitConversion: '(HH:MM:SS)',
  },
  {
    name: 'Driving duration',
    id: 'RunningDuration',
    unitConversion: '(%)',
  },
  { name: 'Fuel Consumed', id: 'FuelConsumed', unitConversion: '(ltrs)' },
  { name: 'Count', id: 'Count' },
  { name: 'Kms', id: 'Kms' },
  { name: 'HH:MM:SS', id: 'HH:MM:SS' },
  { name: 'Count', id: 'Count' },
  { name: 'HH:MM:SS', id: 'HH:MM:SS' },
  { name: '% of overall running', id: 'idlingPercentage' },
  { name: 'Fuel consumed', id: 'idlingFuelConsumed', unitConversion: '(ltrs)' },
  { name: 'Potential Savings', id: 'PotentialSaving', unitConversion: '(INR)' },
  { name: 'Count', id: 'Count' },
  { name: 'Kms', id: 'Kms' },
  { name: 'HH:MM:SS', id: 'HH:MM:SS' },
  { name: 'Count', id: 'noOfexcessiveDrivingAlerts' },
  { name: 'Kms', id: 'excessiveDriving_distance' },
  { name: 'HH:MM:SS', id: 'excessiveDriving_duration' },
  { name: 'Count', id: 'noOfNightDrivingAlerts' },
  { name: 'Kms', id: 'totalNightDrivingDistance' },
  { name: 'HH:MM:SS', id: 'totalNightDrivingHours' },
];

export const reportType = [
  { id: 'day', name: 'Day Wise' },
  { id: 'trip', name: 'Trip Wise' },
  { id: 'per-trip', name: 'Per Trip' },
];
